let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gfBrQ")).then(() => parcelRequire('f17cV'));